
import * as R from "ramda";
import {matchPath, withRouter} from "react-router";
import {Tabs} from "antd";
import React from "react";

// example items:
//
// const items = [
//   {
//     key: 'mycompany',
//     text: 'My Company',
//     dest: params => `/bids/${params.bidId}/contacts/mycompany`,
//     selected: { path: `/bids/:bidId/contacts/mycompany` }
//   },
//   {
//     key: 'all',
//     text: 'Contacts',
//     dest: params => `/bids/${params.bidId}/contacts/`,
//     selected: { path: `/bids/:bidId/contacts/`, exact: true }
//   },
//   {
//     key: 'pending',
//     text: 'Pending Invites',
//     dest: params => `/bids/${params.bidId}/contacts/pending`,
//     selected: { path: `/bids/:bidId/contacts/pending` }
//   },
//   {
//     key: 'email',
//     text: 'Email Invites',
//     dest: params => `/bids/${params.bidId}/contacts/email`,
//     selected: { path: `/bids/:bidId/contacts/email` }
//   },
//
// ];

export const RoutedTabsFactory = (items, defaultItem, props = {}) => {
  class NavBar extends React.Component {
    handleChange = (activeKey) => {
      const {history, match: {params}} = this.props;
      history.push(items.find(item => item.key === activeKey).dest(params));
    };

    render() {
      const {location} = this.props;
      const {force = false} = props;
      let selected = R.defaultTo(defaultItem, R.prop('key', items.find(item => matchPath(location.pathname, item.selected))));
      return (
        <Tabs activeKey={selected} onChange={!force && this.handleChange} onTabClick={force && this.handleChange} {...props}
        >
          {items.map(item => <Tabs.TabPane tab={<span>{item.icon}{item.text}</span>} key={item.key}/>)}
        </Tabs>
      );
    }
  }
  return withRouter(NavBar);
};




// WEBPACK FOOTER //
// ./src/components/Boilerplate/RoutedTabs.js